export default {
  zoomToFit: 'Zoom to fit',
  arrangeNodes: 'Arrange',
  zoomIn: 'Zoom in',
  zoomOut: 'Zoom out',
  more: 'More functions',
  backgroundContextMenu: {
    addNode: {
      title: 'Add node',
      emitter: 'Emitter',
      function: 'Function',
      operator: 'Operator',
      variable: 'Variable',
    },
    preview: {
      title: 'Preview',
      hideAll: 'Hide all',
    },
  },
};
